import { render, staticRenderFns } from "./MyInput.vue?vue&type=template&id=d996b7ba&scoped=true&"
import script from "./MyInput.vue?vue&type=script&lang=js&"
export * from "./MyInput.vue?vue&type=script&lang=js&"
import style0 from "./MyInput.vue?vue&type=style&index=0&id=d996b7ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d996b7ba",
  null
  
)

export default component.exports